export const environment = {
  production: true,
  googleClientID: '877532818111-kq0v9dkrfpgeova6e6ulplinsegs6q24.apps.googleusercontent.com',
  aws: {
    s3PrivateDomain: 'https://s3.amazonaws.com/cci-prod-private/'
  },
  okta: {
    issuer: 'https://racap.okta.com',
    clientId:  '0oak6o636ltSBWiP34x7',
    callbackUrl: '/login/callback',
  }
};
